export {
  StakingDialogContent as StakingDialogContentLegacy,
  StakingDialog as StakingDialogLegacy,
} from './staking-dialog';
